import posthog from 'posthog-js';
import { HOSTNAME_IS_TEST, IS_PROD, IS_STAGING } from '../../constants/environment';
import { requestHandler } from '../../utils/generalUtils';
import {
    deauthenticateUser,
    getDevHost,
    getLastAccountId,
    isUserAuthenticated,
    setDevHost,
    setLastAccountId,
} from '../../utils/tokenManager';
import actions from './appActions';

const editUserField = (id, field, value) => async (dispatch) => {
    const res = await requestHandler('PUT', `/auth/users/${id}`, {
        field,
        value,
    });
    return dispatch(actions.setUser(res.payload.user));
};

const editClientField = (clientId, field, value, userId) => async (dispatch) => {
    const res = await requestHandler('PUT', `/auth/clients/${clientId}`, {
        field,
        value,
        userId,
    });
    return dispatch(actions.setUser(res.payload.user));
};

const fetchUser = () => async (dispatch) => {
    try {
        const { user, source } = isUserAuthenticated();
        const lastAccountId = getLastAccountId();
        if (!user || !user.id) return deauthenticateUser();
        let reqUrl = `/auth/user?domain=${
            IS_PROD || (IS_STAGING && !HOSTNAME_IS_TEST) ? window.location.host : getDevHost()
        }`;
        if (lastAccountId) reqUrl += `&lastId=${lastAccountId}`;
        if (source === 'session') {
            reqUrl = `/auth/sessionUser?domain=${
                IS_PROD || (IS_STAGING && !HOSTNAME_IS_TEST) ? window.location.host : getDevHost()
            }`;
        }

        const res = await requestHandler('GET', reqUrl);
        if (res.success) {
            if (source === 'local' && res.payload.user && res.payload.user.activeClient) {
                setLastAccountId(res.payload.user.activeClient.id);
            }
            posthog.identify(res.payload.user.id.toString(), {
                email: res.payload.user.email,
                name: `${res.payload.user.firstName} ${res.payload.user.lastName}`,
                clientId: res.payload.user.activeClient?.id,
                brand: res.payload.user.activeClient?.accountName,
                userType: res.payload.user.activeClient?.userClients.userType,
            });
            return dispatch(actions.setUser(res.payload.user));
        }

        return deauthenticateUser();
    } catch (e) {
        console.log('error at fetchUser', e);
        return deauthenticateUser();
    }
};

const revokeAccess = (id) => async (dispatch) => {
    posthog.reset();
    dispatch(actions.revokeAccessFE());
    await requestHandler('DELETE', `/auth/public/session/${id}`);
    dispatch(actions.revokeAccessFE());
};

const setClientNetworkURL = (influencerId, url, network, userId) => async (dispatch) => {
    const res = await requestHandler('PUT', `/auth/clientNetworks/${influencerId}`, {
        url,
        network,
        userId,
    });
    if (res.success) dispatch(actions.setUser(res.payload.user));
};

const fetchActiveClient = (clientId) => async (dispatch) => {
    const res = await requestHandler('GET', `/auth/account/${clientId}`);
    setLastAccountId(clientId);
    if (res.success) {
        if (process.env.NODE_ENV === 'development') {
            setDevHost(res.payload.hubDomain);
        }
        dispatch(actions.setActiveClient(res.payload));
    }
};

const setSideNavPinned = (sideNavPinned) => async (dispatch) => {
    dispatch(actions.setSideNavPinned(sideNavPinned));
};

export default {
    ...actions,
    editUserField,
    fetchUser,
    editClientField,
    setClientNetworkURL,
    revokeAccess,
    fetchActiveClient,
    setSideNavPinned,
};
